var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextInput',{staticClass:"w-auto substitutes-count-input",attrs:{"value":_vm.teamFullSize,"disabled":"","type":"text","size":"3","label":_vm.$t('_web_tournament_settings_team-final-size-label', 'Total roster size'),"tooltip":_vm.$t(
      '_web_tournament_settings_team-final-size-help',
      'squad size + substitutes'
    )}})}
var staticRenderFns = []

export { render, staticRenderFns }